export default __webpack_public_path__ + "sepa-bank-transfer.b367cd4.svg";